import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {HorseResponse} from '../../models/response.module';
import {formatDateDMYDots} from '../../../@core/utils/utils.service';

@Component({
  selector: 'app-horse-details-modal',
  standalone: false,
  templateUrl: './horse-details-modal.html',
  styleUrls: ['./horse-details-modal.css']
})
export class HorseDetailsModal {
  @Input() horse!: HorseResponse;

  constructor(public activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.dismiss();
  }

  formatDate(date: Date | string | null | undefined): string {
    if (!date) return '-';
    return formatDateDMYDots(date);
  }

  getGenderLabel(gender: number | null | undefined): string {
    if (gender === null || gender === undefined) return '-';
    const genders: { [key: number]: string } = {
      0: 'Mare',
      1: 'Stallion',
      2: 'Gelding'
    };
    return genders[gender] || '-';
  }

  getAge(): string {
    if (!this.horse?.date_of_birth) return '-';
    const birthDate = new Date(this.horse.date_of_birth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return `${age} years`;
  }

  hasImages(): boolean {
    return !!(this.horse?.image_url || this.horse?.pedigree_image_url || this.horse?.vaccination_card_url);
  }

  openImage(url: string) {
    window.open(url, '_blank');
  }

  isVaccinationOverdue(): boolean {
    if (!this.horse?.next_vaccination_date) return false;
    const nextVaccDate = new Date(this.horse.next_vaccination_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return nextVaccDate < today;
  }
}
